
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[_network]/accounts/[_id]",
      function () {
        return require("private-next-pages/[_network]/accounts/[_id].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[_network]/accounts/[_id]"])
      });
    }
  